import type { PillTone } from "igfd-ui/src/admin";

import type { RestaurantEnv } from "@dashboard/types";

// Env chip tone, shared by the workspaces table, switcher, and plan page so the
// same environment always reads the same colour.
export function envTone(env: RestaurantEnv): PillTone {
  if (env === "prod") {
    return "success";
  }
  if (env === "demo") {
    return "takeNote";
  }
  return "informative";
}
